export const StorageKeys = {
  AccessToken: 'access_token',
  RefreshToken: 'refresh_token',
  AuthData: 'auth_data',
  Profile: 'profile',
  CustomerProfile: 'customerProfile',
  WorkingCompany: 'working_company',
  WorkingCompanyName: 'working_company_name',
  WorkingCompanyInfo: 'working_company_info',
  FrewieShoppingCart: 'frewie_shopping_cart',
  CustomerInfo: 'customer_info',
  // CompanyOptionInfo: 'company_option_info',
  IsRemember: 'is_remember',
  ShoppingCart: 'shopping_cart',

  // Table filters
  ReactTableFilters: {
    CompanyListFilters: 'company_list_filters',
    CountryListFilters: 'country_list_filters',
    NotificationDetailFilters: 'notification_detail_list_filters',
    SettingListFilters: 'setting_list_filters',
    CurrencyListFilters: 'currency_list_filters',
    BankListFilters: 'bank_list_filters',
    UomListFilters: 'uom_list_filters',
    SmsListFilters: 'sms_list_filters',
    NotificationListFilters: 'notification_list_filters',
    TaxGroupListFilters: 'tax_group_list_filters',
    TaxCodeListFilters: 'tax_code_list_filters',
    ItemTaxGroupListFilters: 'item_tax_group_list_filters',
    UserListFilters: 'user_list_filters',
    LogListFilters: 'log_list_filters',
    ReceivedOrderListFilters: 'received_order_list_filters',
    TransactionListFilters: 'transaction_list_filters',
    InvoiceListFilters: 'invoice_list_filters',
    InvoiceDetailListFilters: 'invoice_detail_list_filters',
    WalletListFilters: 'wallet_list_filters',
    WalletTransactionListFilters:  'wallet_transaction_list_filters',
    PaymentTermListFilters: 'payment_term_list_filters',
    FrewiePlatformListFilters: 'frewie_platform_list_filters',
    MoreDirectoryListFilters: 'more_directory_list_filters',
    OfferGroupListFilters: 'offer_group_list_filters',
    RecommendListFilters: 'recommend_list_filters',
    PartnerOfferListFilters: 'partner_offer_list_filters',
    PromotionListFilters: 'promotion_list_filters',
    BestSellingListFilters: 'best_selling_list_filters',
    GiftBackgroundImageListFilters: 'gift_background_image_list_filters',
    CustomerListFilters: 'customer_list_filters',
    CustomerGroupListFilters: 'customer_group_list_filters',
    MembershipListFilters: 'membership_list_filters',
    ServiceMovementJournalListFilters: 'service_movement_journal_list_filters',
    ConsumerListFilters: 'consumer_list_filters',
    ConsumerGroupListFilters: 'consumer_group_list_filters',
    ConsumerAffiliateRegistrationListFilters: 'consumer_affiliate_registration_list_filters',
    ConsumerGoalListFilters: 'consumer_goal_list_filters',
    ConsumerAffiliateListFilters: 'consumer_affiliate_list_filters',
    FrewieCouponListFilters: 'frewie_coupon_list_filters',
    CouponAutomationListFilters: 'coupon_automation_list_filters',
    CouponConsumerListFilters: 'coupon_consumer_list_filters',
    FrewieCouponTransactionListFilters: 'frewie_coupon_transaction_list_filters',
    AppointmentListFilters: 'appointment_list_filters',
    HolidayListFilters: 'holiday_list_filters',
    ProductReviewListFilters: 'product_review_list_filters',
    ConsumerCommissionListFilters: 'consumer_commission_list_filters',
    MovementJournalListFilters: 'movement_journal_list_filters',
    UsageReportListFilters: 'usage_report_list_filters',
    CostTypeSetupListFilters: 'cost_type_setup_list_filters',
    WarrantyTypeListFilters: 'warranty_type_list_filters',
    WarrantyListFilters: 'warranty_list_filters',
    DimensionSetupListFilters: 'dimension_setup_list_filters',
    LocationUnitListFilters: 'location_unit_list_filters',
    LocationSortingListFilters: 'location_sorting_list_filters',
    ProductCategoryListFilters: 'product_category_list_filters',
    ProductTypeListFilters: 'product_type_list_filters',
    FrewiePlanListFilters: 'frewie_plan_list_filters',
    FrewieSerialNumberListFilters: 'frewie_serial_number_list_filters',
    LocationListFilters: 'location_list_filters',
    BrandListFilters: 'brand_list_filters',
    AgentListFilters: 'agent_list_filters',
    PurchaseOrderListFilters: 'purchase_order_list_filters',
    SparkIccidAuditLogListFilters: 'spark_iccid_audit_log_list_filters'
  }
};
